class TimeUtil {
  public static display_date(date: string | undefined | null): string {
    if (date) {
      const firstSplit = date.split("T");
      if (firstSplit.length < 1) {
        return "";
      }

      const secondSplit = firstSplit[0].split("-");
      if (secondSplit.length !== 3) {
        return "";
      }

      return secondSplit.reverse().join(".");
    }

    return "";
  }

  public static display_month_year(date: string | undefined | null): string {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    if (date) {
      const firstSplit = date.split("T");
      if (firstSplit.length < 1) {
        return "";
      }

      const secondSplit = firstSplit[0].split("-");
      if (secondSplit.length !== 3) {
        return "";
      }

      const monthIndex = parseInt(secondSplit[1]);
      if (isNaN(monthIndex)) {
        return "";
      }

      return monthNames[monthIndex - 1] + " " + secondSplit[0];
    }

    return "";
  }
}

export default TimeUtil;
